import { ReactNode } from 'react';
import { cn } from 'src/utils/@/lib/utils';
import './toast.css';

const ReactHotToast = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <div className={cn('react-hot-toast-root', className)}>{children}</div>;
};

export default ReactHotToast;
